import { Arts } from "../types/studioFolder";
import api from "./api";

export const listDetailsArt = async (id: number): Promise<Arts> => {
  const params = {
    id_tabloide: id,
  };

  const response = await api.get(
    "tabloide-digital-p1-prd/prd/crm/getTabloidesDigitais",
    {
      params,
    }
  );

  return response.data[0];
};
